import { styled } from "../../../stitches.config";
import { ScrollStyles } from "../../common/common.style";
import { Box } from "../../primitives";

export const ScrollContainer = styled(Box, {
  width: "90%",
  margin: "auto",
  height: "calc(100vh - 140px)",
  overflowY: "auto",
  border: "1px solid #ccc",
  borderRadius: 6,
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  ...ScrollStyles,
});

export const StyledTable = styled("table", {
  borderCollapse: "collapse",
  width: "100%",
  minWidth: 1600,
});

export const Th = styled("th", {
  borderBottom: "2px solid #333",
  padding: "12px 15px",
  textAlign: "left",
  backgroundColor: "#f9f9f9",
  position: "sticky",
  top: 0,
  zIndex: 1,
});

export const Td = styled("td", {
  padding: "10px 15px",
  borderBottom: "1px solid #ddd",
  fontSize: 14,
});

export const StatusBadge = styled("span", {
  fontWeight: "bold",
  variants: {
    status: {
      PENDING: { color: "orange" },
      SUCCESS: { color: "green" },
      FAILED: { color: "red" },
      NOT_SUPPORTED: { color: "red" },
    },
  },
});
